//NOTE: We use this to controll the app initialization flow during impersonation
export const isImpersonationFlow = () => global.document.referrer?.includes('samson');

export const clearSessionData = () => global.sessionStorage.clear();
